import * as yup from "yup";

const fiveWhy = (translate: Function) => yup.object().shape({
	ina003Id: yup.number(),
	ina003Pergunta: yup.string().required(translate("Porquê é requerido")),
	ina003Resposta: yup.string().required(translate("Resposta é requerida"))
});

const addOrChangeSchema = (translate: Function) => yup.object().shape({
	ina002Id: yup.number(),
	ina002Causa: yup.string().required(translate("Causa é requerida")),
	ina002Fato: yup.string().required(translate("Fato é requerido")),
	intba003: yup.array().of(fiveWhy(translate))
});

export default addOrChangeSchema;
